import {JobStatusType, JobTypeType, PaginationDirection, Status} from 'commonTypes'
import {PaginationState, SortingState} from '@tanstack/react-table'
import {DatabaseMetadata, LegionJob, PageInfo, JobTypeActionOptions} from 'graphql-api'

const defaultJobsState = {
  gridSession: {
    pageSizeOptions: [25, 50, 100, 500, 1000],
    pagination: {
      pageIndex: 0,
      pageSize: 50,
    } as PaginationState,
    pageCount: 1,
    resultsCount: 0,
    cursor: '',
    paginationDirection: PaginationDirection.NEXT,
    pageInfo: {
      startCursor: null,
      endCursor: null,
    } as PageInfo,
    sorting: [
      {id: 'jobId', desc: true},
    ] as SortingState,
    filters: {
      searchQuery: '',
      jobType: [] as JobTypeType[],
      jobStatus: [] as JobStatusType[],
      databaseId: [] as string[],
    },
    filterOptions: {
      raveUrl: [] as DatabaseMetadata[],
    },
  },
  rescheduleJobs: {
    permissible: {} as RescheduleJobCandidatesType,
    selected: {} as RescheduleJobCandidatesType,
  },
  showFilters: false,
  showDetails: false,
  jobIdToCopy: '',
  jobIdCopyTimer: {} as ReturnType<typeof setTimeout>,
  jobIdCopiedTimer: {} as ReturnType<typeof setTimeout>,
  jobs: [] as LegionJob[],
  job: {} as LegionJob,
  jobTypeActionOptions: {
    status: Status.IDLE,
    error: null as any,
    requestId: null as any,
    options: [] as JobTypeActionOptions[],
  },
  status: Status.IDLE,
  statusDetails: Status.IDLE,
  error: null as any,
}

export type RescheduleJobCandidatesType = {[key: string]: boolean}

export type GridSessionType = typeof defaultJobsState.gridSession

export type FiltersType = typeof defaultJobsState.gridSession.filters

export type JobsStateType = typeof defaultJobsState

export default defaultJobsState
